import { Box, Button, List, ListItem, ListItemIcon, ListItemText, Modal, styled, Typography, useTheme } from "@mui/material";
import { IconCheck } from "@tabler/icons-react";
import { useSelector } from "react-redux";
import { projectDetails, usersCreditsYearly } from "../../../common/constant";

const BoxWrapper = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  backgroundColor: theme.palette.background.default,
  border: `2px solid ${theme.palette.divider}`,
  borderRadius: "6px",
  padding: "30px 50px",
  "@media screen and (max-width:600px)": {
    width: "90%",
  },
  "& .BtnWrapper": {
    "& button": {
      textTransform: "none",
      backgroundColor: theme.palette.primary.main,
      color: "#ffffff",
      borderRadius: "5px",
      boxShadow: "none",
      padding: "7px 22px",
      whiteSpace: "nowrap",
      width: "100%",
      "&:focus": {
        outline: "none",
      },
      "&.OutlineBtn": {
        color: theme.palette.primary.main,
        backgroundColor: "transparent",
        border: `2px solid ${theme.palette.primary.main}`,
        padding: "6px 22px",
        "&:hover": {
          backgroundColor: theme.palette.primary.main,
          color: "#fff",
        },
      },
    },
  },
}));

function PlanDetails({ open, handleClose, viewDetails }) {
  const { userData } = useSelector(state => state.reducer);
  const theme = useTheme();
  return (
    <Modal open={open}>
      <BoxWrapper>
        <Typography variant="subtitle1" fontSize="24px" mb={3} fontWeight={700} lineHeight={1} textAlign="center" color={theme.palette.mode === "dark" ? "#ffffff" : "#2A3547"}>
          {userData?.isAnnualSubscription
            ? usersCreditsYearly[viewDetails || userData?.subscriptionCredits?.subscriptionType]?.projectName
            : projectDetails[viewDetails || userData?.subscriptionCredits?.subscriptionType]?.projectName}
        </Typography>
        <Box>
          <Box display="flex" justifyContent="center" color={theme.palette.mode === "dark" ? "#ffffff" : "#2A3547"}>
            <Typography fontSize={{ xs: "30px", sm: "40px" }} fontWeight="700">
              ₹{" "}
              {userData?.isAnnualSubscription
                ? usersCreditsYearly[viewDetails || userData?.subscriptionCredits?.subscriptionType]?.price
                : projectDetails[viewDetails || userData?.subscriptionCredits?.subscriptionType]?.price}
            </Typography>
            <Typography fontSize="15px" fontWeight={400} ml={1} mt={1}>
              {userData?.isAnnualSubscription ? "/yearly" : "/monthly"}
            </Typography>
          </Box>
        </Box>
        <Box mt={2}>
          <List>
            <Box>
              <ListItem disableGutters>
                <ListItemIcon sx={{ color: "primary.main", minWidth: "32px" }}>
                  <IconCheck width={18} />
                </ListItemIcon>
                <ListItemText sx={{ color: theme.palette.mode === "dark" ? "#ffffff" : "#212529" }}>
                  {userData?.isAnnualSubscription
                    ? projectDetails[viewDetails || userData?.subscriptionCredits?.subscriptionType]?.project
                    : projectDetails[viewDetails || userData?.subscriptionCredits?.subscriptionType]?.project}{" "}
                  Project / Month
                </ListItemText>
              </ListItem>
            </Box>
            <Box>
              <ListItem disableGutters>
                <ListItemIcon sx={{ color: "primary.main", minWidth: "32px" }}>
                  <IconCheck width={18} />
                </ListItemIcon>
                <ListItemText sx={{ color: theme.palette.mode === "dark" ? "#ffffff" : "#212529" }}>
                  {userData?.isAnnualSubscription
                    ? projectDetails[viewDetails || userData?.subscriptionCredits?.subscriptionType]?.siteAudit
                    : projectDetails[viewDetails || userData?.subscriptionCredits?.subscriptionType]?.siteAudit}{" "}
                  Site audit / Month
                </ListItemText>
              </ListItem>
            </Box>
            <Box>
              <ListItem disableGutters>
                <ListItemIcon sx={{ color: "primary.main", minWidth: "32px" }}>
                  <IconCheck width={18} />
                </ListItemIcon>
                <ListItemText sx={{ color: theme.palette.mode === "dark" ? "#ffffff" : "#212529" }}>
                  {userData?.isAnnualSubscription
                    ? projectDetails[viewDetails || userData?.subscriptionCredits?.subscriptionType]?.blogGeneration
                    : projectDetails[viewDetails || userData?.subscriptionCredits?.subscriptionType]?.blogGeneration}{" "}
                  Blog generation / Month
                </ListItemText>
              </ListItem>
            </Box>
            <Box>
              <ListItem disableGutters>
                <ListItemIcon sx={{ color: "primary.main", minWidth: "32px" }}>
                  <IconCheck width={18} />
                </ListItemIcon>
                <ListItemText sx={{ color: theme.palette.mode === "dark" ? "#ffffff" : "#212529" }}>
                  {userData?.isAnnualSubscription
                    ? projectDetails[viewDetails || userData?.subscriptionCredits?.subscriptionType]?.keywordRanking
                    : projectDetails[viewDetails || userData?.subscriptionCredits?.subscriptionType]?.keywordRanking}{" "}
                  Keyword rankings / Month
                </ListItemText>
              </ListItem>
            </Box>
            <Box>
              <ListItem disableGutters>
                <ListItemIcon sx={{ color: "primary.main", minWidth: "32px" }}>
                  <IconCheck width={18} />
                </ListItemIcon>
                <ListItemText sx={{ color: theme.palette.mode === "dark" ? "#ffffff" : "#212529" }}>
                  {userData?.isAnnualSubscription
                    ? projectDetails[viewDetails || userData?.subscriptionCredits?.subscriptionType]?.keywordResearch
                    : projectDetails[viewDetails || userData?.subscriptionCredits?.subscriptionType]?.keywordResearch}{" "}
                  Keyword researches / Month
                </ListItemText>
              </ListItem>
            </Box>
          </List>
        </Box>
        <Box className="BtnWrapper">
          <Button className="OutlineBtn" onClick={handleClose}>
            Back
          </Button>
        </Box>
      </BoxWrapper>
    </Modal>
  );
}

export default PlanDetails;
